import { TransformDate } from '../../../shared/decorators/transform-date.decorator';
import { TransformInt } from '../../../shared/decorators/transform-int.decorator';
import { DataCardinalityEnum } from '../../../shared/enums/data-cardinality.enum';
import { ApiRequestFilters } from '../../../shared/types/api-request-filters';
import { ApiRequestOrdering } from '../../../shared/types/api-request-ordering';
import { TagDto } from '../../tags/dtos/tag.dto';
import { ReportScheduleTypeEnum } from '../enums/report-schedule-type.enum';
import { ReportTypeEnum } from '../enums/report-type.enum';

import { ReportVariableDto } from './report-variable.dto';

/**
 * Create report DTO
 */
export class CreateReportDto {
	name!: string;
	title?: string;
	subTitle?: string;
	description?: string;
	notes?: string;
	isSystem!: boolean;
	type!: ReportTypeEnum;
	cardinality!: DataCardinalityEnum;
	scheduleType!: ReportScheduleTypeEnum;
	@TransformDate()
	scheduleAt?: Date;
	scheduleCron?: string;
	filters?: ApiRequestFilters;
	ordering?: ApiRequestOrdering;
	@TransformInt()
	templateId?: number;
	variables?: ReportVariableDto[];
	tags?: TagDto[];
}
